import { render, staticRenderFns } from "./StrokeRightIcon.vue?vue&type=template&id=3faf0c8c&"
import script from "./StrokeRightIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports